import { Box } from '@mui/material';
import { FC } from 'react';

import { DatePicker } from 'src/components/date-picker/date-picker';

import { styles } from './styles';
import { RoomsSearchPanelProps } from './types';

export const RoomsSearchPanel: FC<RoomsSearchPanelProps> = ({
    minimumStayDuration,
    moveOutDate,
    moveInDate,
    stayDuration,
    onMoveInDateChange,
    onStayDurationChange,
    onDurationValidityChange,
    onError,
}) => (
    <Box css={styles.searchPanel}>
        <DatePicker
            minimumStayDuration={minimumStayDuration}
            moveOutDate={moveOutDate}
            moveInDate={moveInDate}
            stayDuration={stayDuration}
            onMoveInDateChange={onMoveInDateChange}
            onStayDurationChange={onStayDurationChange}
            onDurationValidityChange={onDurationValidityChange}
            onError={onError}
        />
    </Box>
);
